import React from "react";

interface LoginLayoutProps {
  children: React.ReactNode;
}

export const LoginLayout: React.FC<LoginLayoutProps> = ({ children }) => {
  return <div className="flex flex-row h-screen w-full">{children}</div>;
};
